import { styled, Switch, Tabs } from "@mui/material";

export const ScrollableTabs = styled(Tabs)(() => ({
  borderTop: "1px solid #A8A8BD",
  borderBottom: "1px solid #A8A8BD",
  "& .MuiTab-root": {
    textTransform: "none",
    fontFamily: "Inter",
    color: "#A8A8BD",
    fontWeight: 400,
    padding: "6px 12px",
    minWidth: "0px",
  },
  "& .Mui-selected": {
    color: "#006AFF",
    fontWeight: 500,
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .MuiTabs-flexContainer": {
    justifyContent: "center",
  },
}));

export const ScrollableTabsSelected = styled(Tabs)(() => ({
  borderTop: "1px solid #A8A8BD",
  borderBottom: "1px solid #A8A8BD",
  padding: "10px 0px",
  minHeight: 0,
  "& .MuiTab-root": {
    textTransform: "none",
    fontFamily: "Inter",
    color: "#A8A8BD",
    fontWeight: 400,
    padding: "10px 16px",
    minWidth: "0px",
    minHeight: 0,
    borderRadius: "10px",
  },
  "& .Mui-selected": {
    color: "#006AFF",
    fontWeight: 500,
    backgroundColor: "#E5F0FF",
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
  // "& .MuiTabs-flexContainer": {
  //   justifyContent: "center",
  // },
}));

export const StyledSwitch = styled(Switch)(() => ({
  width: "70px",
  height: "50px",
  "& .MuiSwitch-switchBase": {
    top: 15,
    left: 15,
    padding: 0,
  },
  "& .Mui-checked": {
    color: "#FFFFFF !important",
  },
  "& .MuiSwitch-track": {
    borderRadius: "20px",
    opacity: "1 !important",
    backgroundColor: "rgba(23, 23, 23, 0.05)",
    boxShadow: "inset 0px 0px 4px rgba(0, 0, 0, 0.1)",
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: "20px",
    height: "20px",
  },
}));
